import React, { Component } from 'react'
import './detay.css'
import Dots from '../activityIndicators/dots'

class DetayMainContainer extends Component {
    render() {
        return (
            <React.Fragment>
                {this.props.sending && <Dots />}
                <div className="detay-main-container" style={this.props.sending === true ? {display: "none"} : {}}>
                    {this.props.children}
                </div>
            </React.Fragment>
        )
    }
}

export default DetayMainContainer